import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { ReactComponent as GuidedSellingRestartIcon } from "../../../assets/icons/Icon/DKT/guided-selling-restart.svg";
import React from "react";
import { SwarovskiButton } from "../../_shared-components/ui-elements/SwarovskiButton";
import { CSS_MQ } from "../../../styles/breakpoints";
import type { GuidedSellingTranslation } from "@swo/storefront";

export const StepNavigationBarRestartButton: ReactTFC<{
  onClickRestart: () => void;
  isDisabled: boolean;
  translations: GuidedSellingTranslation;
}> = props => {
  return (
    <SwarovskiButton
      onClick={props.onClickRestart}
      disabled={props.isDisabled}
      as={"button"}
      variant={"plain-underline"}
      size={"tiny"}
      css={css`
        overflow: hidden;

        @media (pointer: fine) {
          svg {
            transition: rotate 0.3s ease-out;
            transform: rotate(0deg);
          }

          &:hover {
            svg {
              transform: rotate(-359deg);
              transition: all 0.3s ease-out;
            }
          }
        }

        ${CSS_MQ.atMostSm} {
          ._label {
            font-size: 12px;
          }
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          ${CSS_MQ.atLeastMd} {
            flex-direction: row;
          }
        `}
      >
        <GuidedSellingRestartIcon
          css={css`
            width: 16px;
            height: 16px;

            ${CSS_MQ.atMostSm} {
              align-self: center;
            }

            ${CSS_MQ.atLeastMd} {
              padding: 4px;

              width: 24px;
              height: 24px;
            }
          `}
        />
        <span
          className={"u-uppercase _label"}
          css={css`
            font-size: 16px;
            letter-spacing: 1px;
            line-height: 21px;

            ${CSS_MQ.atLeastMd} {
              align-items: center;
              display: flex;
            }
          `}
        >
          {props.translations.restart.value}
        </span>
      </div>
    </SwarovskiButton>
  );
};

/*
<button
      css={css`
        display: grid;
        grid-template-columns: 20px auto;
        grid-gap: 8px;
        align-items: center;

        ${fontColor.black};
        &[disabled] {
          color: ${CSS_COLORS.Grey};
          cursor: not-allowed;
        }


      `}
    >
 */
